module.exports = __webpack_public_path__ + "img/sharedgreenicon.efb80fbd.svg";